<!--
  功能：功能描述
  作者：xixi
  时间：2021年11月22日 10:31:51
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
  <div class="main">
    <div class="list" v-if="list.length">
      <div class="item" v-for="item in list" :key="item.name">
        <el-image class="img" @click="goItem(item.path)" :src="item.icon.default"></el-image>
        <span>{{ item.name }}</span>
      </div>
    </div>
    <div class="version">版本号：1.0.8</div>
    <myDialog :dialogVisible="dialogVisible" question="是否退出当前账号？" @close="close" @setup="out" dialogWidth="66%"></myDialog>
    <myDialog :dialogVisible="dialogVisible1" :question="question" @close="close1" dialogWidth="50%"></myDialog>
    <audio id="resource" ref="up" :src="audioSrc" controls style="display: none"></audio>
  </div>
</template>

<script>
import myDialog from '@/common/dialog.vue'
import { registerScan } from '@/tool/posRun'
export default {
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {
    myDialog
  },
  // 组件状态值
  data() {
    return {
      dialogVisible: false,
      dialogVisible1: false,
      SleepNoticeList: [], //报警记录
      question: '',
      tokenBaidu: '',
      audioSrc: require('@/assets/music/lichuangjingbao.mp3'),
      iconListN: [
        {
          name: '护理',
          icon: require('@/assets/imgs/home-1.png'),
          path: 'nursingOne'
        },
        {
          name: '服药',
          icon: require('@/assets/imgs/fuyao.png'),
          path: 'medicine'
        },
        {
          name: '治疗',
          icon: require('@/assets/imgs/home-2.png'),
          path: 'cure'
        },
        {
          name: '评估',
          icon: require('@/assets/imgs/home-3.png'),
          path: 'assessment'
        },
        {
          name: '交班',
          icon: require('@/assets/imgs/home-5.png'),
          path: 'nurseShiftExchange'
        },
        {
          name: '扫码',
          icon: require('@/assets/imgs/home-6.png'),
          path: 'scanCode'
        },
        {
          name: '体征记录',
          icon: require('@/assets/imgs/tijian.png'),
          path: 'Physicalrecord'
        },
        {
          name: '膳食计划',
          icon: require('@/assets/imgs/shanshi.png'),
          path: 'food'
        },
        {
          name: '暂离院',
          icon: require('@/assets/imgs/zhanli.png'),
          path: 'leave'
        },
        // {
        //     name:'报警记录', //演示用得已隐藏
        //     icon:require('@/assets/imgs/home-6.png'),
        //     path:'alartRecord'
        // },
        {
          name: '退出',
          icon: require('@/assets/imgs/home-7.png'),
          path: 'out'
        }
      ],

      iconListD: [
        {
          name: '医疗档案',
          icon: require('@/assets/imgs/home-8.png'),
          path: 'record'
        },

        {
          name: '退出',
          icon: require('@/assets/imgs/home-7.png'),
          path: 'out'
        }
      ],
      list: []
    }
  },

  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  created() {
    let active = localStorage.getItem('active') || 'N'

    this.list = this['iconList' + active]
    console.log('  this.list: ', this.list)
    if (localStorage.getItem('isApp') === '0') {
      const blacklist = ['退出', '扫码']
      this.list = this.list.filter((item) => !blacklist.includes(item.name))
    }
  },
  methods: {
    close() {
      this.dialogVisible = false
    },
    close1() {
      this.dialogVisible1 = false
    },
    out() {
      this.$store.commit('loginOut')
      this.$router.push({ name: 'login' })
    },
    goItem(path) {
      if (path) {
        if (path == 'out') {
          this.dialogVisible = true
        } else if (path == 'scanCode') {
          registerScan()
        } else {
          this.$router.push({ name: path })
        }
      } else {
        this.$message({
          message: '暂无此功能!',
          type: 'warning',
          customClass: 'custom-message'
        })
      }
    }
  }
}
</script>

<style scoped>
.main {
  padding-top: 44px;
}
.list {
  display: flex;
  flex-wrap: wrap;
}
.item {
  display: flex;
  flex-direction: column;
  width: 125px;
  height: 125px;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: #434649;
}
.img {
  width: 48px;
  height: 48px;
  margin: 0px auto;
  margin-bottom: 2px;
}

.version {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translate(-50%, 0);
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/components/main.vue